<!-- generic yes/no confirm -->

<p-confirmDialog key='genericConfirm' #confirmDialog width="425" [closable]="false">
  <ng-template pTemplate="message" let-message>
    <div class="container-fluid">
      <div class="row">
        <iui-messages #messages class="ms-auto me-auto"></iui-messages>
      </div>
      <div class="row">
        <div class="col-auto">

          {{message.message}}

        </div>
      </div>
    </div>
  </ng-template>
  <p-footer>
    <div class="d-flex justify-content-end">
      <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="confirmDialog.accept()">Yes</button>
      <button i18n id="screject" class="btn btn-secondary" type="button" (click)="confirmDialog.reject()">No</button>
    </div>
  </p-footer>
</p-confirmDialog>